import { Link } from "wouter";
import { Lock, ShieldCheck } from "lucide-react";

interface FooterProps {
  onTryDemo?: () => void;
}

export function Footer({ onTryDemo }: FooterProps) {
  return (
    <footer className="bg-slate-900 py-14 sm:py-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-10 mb-12">
          <div className="max-w-xs">
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/images/finproject-logo.png" alt="FinProject" className="h-9 w-auto" />
              <span className="font-bold text-lg text-white">FinProject</span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Construction financial management for contracting companies worldwide. Purpose-built for CFOs and project accountants who manage complex project portfolios.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 sm:gap-10">
            <div>
              <div className="text-sm font-semibold text-white mb-4">Product</div>
              <div className="space-y-2.5">
                <a href="/#who-its-for" className="block text-sm text-slate-400 hover:text-white transition-colors">Who It's For</a>
                <a href="/#features" className="block text-sm text-slate-400 hover:text-white transition-colors">Features</a>
                <a href="/#pricing" className="block text-sm text-slate-400 hover:text-white transition-colors">Pricing</a>
                <a href="/#how-it-works" className="block text-sm text-slate-400 hover:text-white transition-colors">How it works</a>
              </div>
            </div>

            <div>
              <div className="text-sm font-semibold text-white mb-4">Account</div>
              <div className="space-y-2.5">
                <Link href="/app/login" className="block text-sm text-slate-400 hover:text-white transition-colors">Sign In</Link>
                <Link href="/signup" className="block text-sm text-slate-400 hover:text-white transition-colors">Create Account</Link>
                {onTryDemo ? (
                  <button onClick={onTryDemo} className="block text-sm text-slate-400 hover:text-white transition-colors cursor-pointer text-left">Try Demo</button>
                ) : (
                  <Link href="/" className="block text-sm text-slate-400 hover:text-white transition-colors">Try Demo</Link>
                )}
              </div>
            </div>

            <div>
              <div className="text-sm font-semibold text-white mb-4">Legal</div>
              <div className="space-y-2.5">
                <Link href="/privacy" className="block text-sm text-slate-400 hover:text-white transition-colors">Privacy Policy</Link>
                <Link href="/terms" className="block text-sm text-slate-400 hover:text-white transition-colors">Terms of Service</Link>
                <Link href="/refund-policy" className="block text-sm text-slate-400 hover:text-white transition-colors">Refund Policy</Link>
              </div>
            </div>

            <div>
              <div className="text-sm font-semibold text-white mb-4">Support</div>
              <div className="space-y-2.5">
                <a href="mailto:support@finproject.io" className="block text-sm text-slate-400 hover:text-white transition-colors">support@finproject.io</a>
                <a href="mailto:support@finproject.io" className="block text-sm text-slate-400 hover:text-white transition-colors">Contact Us</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700/60 pt-8 flex flex-col md:flex-row justify-between items-center gap-5">
          <p className="text-sm text-slate-500">
            © 2026 FinProject · Business Elite LLC, Shams Free Zone, UAE. All rights reserved.
          </p>
          <div className="flex items-center gap-3 flex-wrap justify-center">
            <div className="flex items-center gap-1.5 bg-slate-800 border border-slate-700 rounded-md px-3 py-1.5">
              <Lock className="w-3.5 h-3.5 text-emerald-400" />
              <span className="text-xs font-semibold text-slate-300">Payment secured by Stripe</span>
            </div>
            <div className="flex items-center gap-1.5 bg-slate-800 border border-slate-700 rounded-md px-3 py-1.5">
              <ShieldCheck className="w-3.5 h-3.5 text-blue-400" />
              <span className="text-xs font-semibold text-slate-300">ISO 27001</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
